import type { IMerchantGroupAbstract } from "./MerchantGroup";

export const MerchantGroupQueryParamName = "mg";

export type MerchantGroupQueryParam = IMerchantGroupAbstract | string;

export interface IMerchantGroupContext {
  merchantGroup?: MerchantGroupQueryParam;
}
